wbApp.factory('duePaymentsSvc', ['$resource', '$q', '$filter', '$translate', 'repositorySvc', 'notificationSvc',
    function ($resource, $q, $filter, $translate, repositorySvc, notificationSvc) {

        var DuePayments = $resource('/Api/DuePayments/GetAll', {}, {
            'query': { method: 'GET', isArray: true },
            'getAllForCurrentUser': { method: 'GET', isArray: true, url: '/Api/DuePayments/GetAllForCurrentUser' },
            'getAllForSemester': { method: 'GET', isArray: true, url: '/Api/DuePayments/GetAllForSemester' },
            'getAllForDateRange': { method: 'GET', isArray: true, url: '/Api/DuePayments/getAllForDateRange' },
            'sendRequestForPayment': { method: 'POST', url: '/Api/DuePayments/SendRequestForPayment' },
        });

        var duePayments;
        var filteredDuePayments = [];
        var summaryAll = null;
        var filteredSemesterID;

        function getAllAsync(refresh) {
            if (!duePayments || refresh) {
                duePayments = repositorySvc.get(DuePayments, {});
            }

            return duePayments;
        }

        function getAllForCurrentUser(filterOutOverPayments) {
            var deffered = $q.defer();
            var result = [];
            result.$promise = deffered.promise;

            repositorySvc.customGet('getAllForCurrentUser', DuePayments).$promise.then(
                function (data) {
                    var filtered = !filterOutOverPayments
                        ? data
                        : _.filter(data, function (o) {
                            return o.arrear >= 0;
                        });

                    var sorted = _.orderBy(filtered, ['studentFullName', 'dueDate'], ['asc', 'asc']);
                    var grouped = _.groupBy(sorted, function (value) {
                        return value.studentFullName;
                    });
                    _.forEach(grouped, function (value, key) {
                        result.push({
                            studentFullName: key,
                            duePayments: value
                        });
                    });
                    deffered.resolve(result);
                });
            return result;
        }

        function sendRequestForPayment(invoiceID, typeID, typeReferenceID, typeReference2ID, parentID, isReccuring) {
            DuePayments.sendRequestForPayment({
                invoiceID: invoiceID,
                typeID: typeID,
                typeReferenceID: typeReferenceID,
                typeReference2ID: typeReference2ID,
                userID: parentID,
                isReccuring: isReccuring
            }, success, error);

            function success(data) {
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_MESSAGE_SENT'));
            }

            function error(errorResult) {
                repositorySvc.defaultErrorHandler(errorResult);
            }
        }

        function getAllBySemesterIDAsync(semesterID, refresh) {
            return repositorySvc.customGet('getAllForSemester', DuePayments, {
                semesterID: semesterID
            });
        }

        function getAllByDateRangeAsync(fromDate, toDate) {
            var from = moment(fromDate).startOf('day').toDate();
            var to = moment(toDate).endOf('day').toDate();

            return repositorySvc.customGet('getAllForDateRange', DuePayments, {
                fromDate: from,
                toDate: to
            });
        }

        function calculateSummaryAll() {

            if (summaryAll) {
                return summaryAll;
            }

            var deffered = $q.defer();
            summaryAll = {};
            summaryAll.$promise = deffered.promise;

            var dp = getAllAsync();
            dp.$promise.then(function (data) {
                var result = calculateSummary(data);
                deffered.resolve(angular.extend(summaryAll, result));
            }, function (reason) {
                deffered.reject(reason);
            });

            return summaryAll;
        }

        function calculateSummary(duePayments) {
            var summary = {
                all: 0,
                types: [
                    { name: $filter('invoiceForType')(1), value: 0 },
                    { name: $filter('invoiceForType')(2), value: 0 },
                    { name: $filter('invoiceForType')(3), value: 0 },
                    { name: $filter('invoiceForType')(4), value: 0 }
                ]
            };

            if (!duePayments) {
                return summary;
            }

            for (var p = 0; p < duePayments.length; p++) {
                var duePayment = duePayments[p];

                // Fix for very early gcp invoices without TypeID (it should not happen in production)
                var typeID = duePayment.typeID == 0
                    ? 3
                    : duePayment.typeID - 1;

                summary.all += duePayment.arrear;
                summary.types[typeID].value += duePayment.arrear;
            }

            return summary;
        }

        return {
            getAllAsync: getAllAsync,
            getAllForCurrentUser: getAllForCurrentUser,
            getAllBySemesterIDAsync: getAllBySemesterIDAsync,
            calculateSummary: calculateSummary,
            calculateSummaryAll: calculateSummaryAll,
            sendRequestForPayment: sendRequestForPayment,
            getAllByDateRangeAsync: getAllByDateRangeAsync
        }
    }]);